import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { ThemeType } from "./theme-type";

const theme: ThemeType = {
  typography: {
    body: {
      sizeSmall: 12,
      sizeMedium: 14,
      sizeLarge: 16,
      fontWeightRegular: 400,
      fontWeightStrong: 600,
    },
    heading: {
      sizeSmall: 20,
      sizeBase: 24,
      sizeLarge: 32,
      fontWeight: 600,
    },
    subheading: {
      sizeSmall: 16,
      sizeMedium: 20,
      sizeLarge: 24,
      fontWeight: 400,
    },
  },
  color: {
    background: {
      default: {
        default: colors.gray[100],
        defaultHover: colors.gray[700],
        secondary: colors.gray[800],
        secondaryHover: colors.gray[900],
        tertiary: colors.gray[600],
        tertiaryHover: colors.gray[700],
      },
      neutral: {
        default: colors.slate[400],
        hover: colors.slate[500],
        secondary: colors.slate[900],
        secondaryHover: colors.slate[400],
        tertiary: colors.slate[200],
        tertiaryHover: colors.slate[1000],
      },
      brand: {
        default: colors.brand[800],
        hover: colors.brand[900],
        secondary: colors.brand[600],
        secondaryHover: colors.brand[500],
        tertiary: colors.brand[200],
        tertiaryHover: colors.brand[400],
        disabled: colors.brand[600],
      },
      disabled: {
        default: colors.brand[300],
      },
    },
    text: {
      default: {
        default: colors.gray[900],
        secondary: colors.gray[500],
        tertiary: colors.gray[400],
      },
      neutral: {
        default: colors.slate[900],
        secondary: colors.slate[700],
        tertiary: colors.slate[600],
        onNeutral: colors.slate[100],
        onNeutralSecondary: colors.slate[900],
        onNeutralTertiary: colors.slate[800],
      },
      brand: {
        default: colors.brand[800],
        secondary: colors.brand[600],
        tertiary: colors.brand[500],
        onBrand: colors.brand[100],
        onBrandSecondary: colors.brand[900],
        onBrandTertiary: colors.brand[800],
      },
    },
    border: {
      default: {
        default: colors.gray[300],
        secondary: colors.gray[500],
        tertiary: colors.gray[700],
      },
      neutral: {
        default: colors.slate[900],
        secondary: colors.slate[600],
        tertiary: colors.slate[400],
      },
      brand: {
        default: colors.brand[900],
        secondary: colors.brand[700],
        tertiary: colors.brand[500],
      },
      danger: {
        default: colors.red[700],
      },
      disabled: {
        default: colors.slate[400],
      },
    },
    icon: {
      brand: {
        secondary: colors.brand[900],
      },
    },
    disabled: {
      default: colors.brand[400],
    },
  },
};

// const customTheme = {
//   primary: colors.brand[800],
//   secondary: colors.brand[600],
//   tertiary: colors.brand[600],
// };

const apaTheme = {
  ...theme,
  muiTheme: createTheme({
    palette: {
      mode: "light",
      background: {
        default: colors.gray[100],
        paper: colors.gray[800],
      },
      primary: {
        main: colors.brand[800],
        light: colors.brand[300],
        dark: colors.brand[900],
      },
      secondary: {
        main: colors.slate[400],
        light: colors.slate[200],
        dark: colors.slate[900],
      },
      text: {
        primary: colors.gray[900],
        secondary: colors.gray[500],
        disabled: colors.brand[400],
      },
      action: {
        disabled: colors.slate[400],
      },
      error: {
        main: colors.red[700],
      },
    },
  }),
};

export default apaTheme;
